import { WebsiteColorTheme } from '../types/siteSectionColorTheme';
import { SiteSectionSlug } from '../types/siteSectionSlug';

export enum Color {
	Tertiary1 = '#EF9600',
	Tertiary1Light = '#FCEACC',

	Tertiary2 = '#FFBF3F',
	Tertiary2Light = '#FFF2D9',
	Tertiary2Light80 = '#FFCC65',

	Tertiary3 = '#FCC131',

	PrimaryWhite = '#FFFFFF',
	PrimaryBlue = '#2F3337',
	PrimaryBlueDark = '#2C2E35',
	PrimaryBlueDark2 = '#005166',
	PrimaryBlue1 = '#004F71',
	PrimaryBlue2 = '#007A99',
	PrimaryBlue3 = '#71B2C9',
	PrimaryBlue3Light80 = '#8DC1D4',
	PrimaryBlueLight = '#ADD2F5',
	PrimaryHovered = '#F0F7F9',

	SecondaryBlue1 = '#22828B',
	SecondaryBlue2 = '#98DBCE',
	SecondaryHovered = '#CCDCE3',
	SecondaryFocused = '#CCE4EB',
	SecondaryDarkBlue = '#000E29',
	SecondaryDarkBlue1 = '#00364D',

	BackgroundGradientLight = '#E3EBEE',
	BodyBackground = '#F3F3FB',
	Neutral = '#6E7780',
	Neutral20 = '#E2E4E6',
	Neutral40 = '#C5C9CC',
	Neutral10 = '#F0F1F2',
	Neutral60 = '#A8ADB3',
	OnSurfaceLight = '#585858',

	HeaderButtonBackground = '#205C74',
	OnBackgroundText = '#001D29',
	OnBackgroundText2 = '#1A1A1A',

	BlueGradient = '#1F6F8D',
	HeaderGradientStart = '#6DA9C0',

	FooterLightYellow = '#FFBD4A',
	FooterDarkYellow = '#FF9328',

	DropdownHighlighted = '#E3F0F4',

	// crowdedness
	NoneCrowdedness = '#C6CFD9',
	QuietCrowdedness = '#66B966',
	CrowdedCrowdedness = '#F5C066',
	FullCrowdedness = '#F36666',

	// states
	Success = '#008A00',
	SuccessLight = '#CCE8CC',
	WarningLight = '#FFE5B2',
	Error = '#EB0000',
	ErrorLight = '#FBCCCC',

	// old colors
	PrimaryBlue77 = '#8AB6FF',
	PrimaryBlue87 = '#BDD6FF',
	PrimaryBlue97 = '#E0ECFF',
	PrimaryBlue17 = '#002157',
	OnPrimarySurface = '#FCFCFC',
	SecondaryGreen2 = '#78D64B',
	SecondaryGreen227 = '#36701A',
	SecondaryGreen287 = '#D6F3C9',
	OnSecondaryGreen2 = '#224710',
	Error16 = '#510B01',
	Error46 = '#E72003',
	Error76 = '#FD9586',
	Error96 = '#FEDBD7',
	ErrorDark = '#7A0000',
	Neutral30 = '#4D4D4D',
	Neutral50 = '#808080',
	Neutral70 = '#B3B3B3',
	Neutral80 = '#CCCCCC',
	Neutral92 = '#EBEBEB',
	Neutral94 = '#F0F0F0',

	Tertiary97 = '#FAFBDA',
}

export const websiteColorTheme: WebsiteColorTheme = {
	[SiteSectionSlug.MCO]: {
		secondary: '#FFBD4A',
		secondaryLight: '#FFF2D9',
		secondaryDark: '#FF9328',
	},
	[SiteSectionSlug.ORL]: {
		secondary: '#71B2C9',
		secondaryLight: '#E3F0F4',
		secondaryDark: '#007A99',
	},
	[SiteSectionSlug.BUSINESS]: {
		secondary: '#C1E9E2',
		secondaryLight: '#EAF8F5',
		secondaryDark: '#98DBCE',
	},
	[SiteSectionSlug.MCOCARES]: {
		secondary: '#C1E9E2',
		secondaryLight: '#EAF8F5',
		secondaryDark: '#98DBCE',
	},
};
